import { Navigate, Outlet, useParams } from 'react-router-dom';
import AuthCookieHandler from '@/services/AuthCookieHandler';

const AdminRoute = () => {
  const authCookieHandler = new AuthCookieHandler();
  const { id } = useParams<{ id: string }>();

  if (!authCookieHandler.isAuthenticated()) {
    return <Navigate to={`/qr/${id}/admin-login`} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
